import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AuthProvider from './components/auth/AuthProvider';
import Header from './components/Header'
import Hero from './components/Hero'
import Stats from './components/Stats'
import Features from './components/Features'
import Solutions from './components/Solutions'
import Cases from './components/Cases'
import Testimonials from './components/Testimonials'
import Footer from './components/Footer'
import Console from './components/console/Console'
import { JobManagement } from './components/console/job-management';
import { SubmitJob } from './components/console/job-management';
import { UserManual } from './components/console/system-management';
import { KeyPairManagement } from './components/console/user-center';
import Contact from './components/Contact';

// 营销页面组件
const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-white">
      <Header />
      <main>
        <Hero />
        <Stats />
        <Features />
        <Solutions />
        <Cases />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/console/*" element={<Console />}>
            <Route path="job-management" element={<JobManagement />} />
            <Route path="submit-job" element={<SubmitJob />} />
            <Route path="user-manual" element={<UserManual />} />
            <Route path="key-pair-management" element={<KeyPairManagement />} />
          </Route>
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              maxWidth: '400px',
              padding: '16px 24px',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              fontSize: '16px',
              textAlign: 'center',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4ade80',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </Router>
    </AuthProvider>
  )
}

export default App 